      document.addEventListener("DOMContentLoaded", function () {
//window.onload = function () {
				const swiper = new Swiper(".swiper", {
					loop: true,
					speed: 2000,
					autoplay: {
						delay: 2000,
					},
					effect: "fade",
					fadeEffect: {
						crossFade: true,
					},
				});
			});

 document.addEventListener("DOMContentLoaded", function () {
			//$(function () {
				$(window).scroll(function () {
					$(".fadein").each(function () {
						var position = $(this).offset().top;
						var scroll = $(window).scrollTop();
						var windowHeight = $(window).height();
						if (scroll > position - windowHeight + 100) {
							$(this).addClass("active");
						}
					});
				});
			});

